<template>
  <div class="rich-content" v-html="html" />
</template>

<script>
import { resolveImageUrl } from '@/utils/image';

export default {
  name: 'RichContent',
  props: {
    content: { type: String, default: '' }
  },
  computed: {
    html() {
      if (!this.content) return '';
      return this.content.replace(
        /(<img[^>]+src=["'])([^"']+)(["'])/gi,
        (match, prefix, src, suffix) => prefix + resolveImageUrl(src) + suffix
      );
    }
  }
};
</script>

<style scoped>
.rich-content {
  font-size: 15px;
  line-height: 1.9;
  color: #606266;
  word-break: break-word;
}
.rich-content >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 12px 0;
}
.rich-content >>> p {
  margin: 0 0 14px;
}
.rich-content >>> h1,
.rich-content >>> h2,
.rich-content >>> h3 {
  color: #303133;
  margin: 20px 0 12px;
}
</style>
